/**
 * Backend API endpoint paths (Strapi 5).
 * Ported 1:1 from racore-app/constants/BackendAPI.ts — paths are unchanged
 * since the backend is shared between the legacy and web frontends.
 */

// ─── Auth / token ────────────────────────────────────────────────────────────
export const AUTH_REFRESH_URI = '/auth/refresh';

// ─── Spotify OAuth — hybrid flow (native OAuth + callback conversion) ─────────
export const SPOTIFY_CONNECT_URI = '/connect/spotify';
export const SPOTIFY_CALLBACK_URI = '/external-service-access/spotify/callback';

// ─── Google OAuth — hybrid flow ──────────────────────────────────────────────
export const GOOGLE_CONNECT_URI = '/connect/google';
export const GOOGLE_CALLBACK_URI = '/external-service-access/google/callback';

// ─── User ────────────────────────────────────────────────────────────────────
export const USER_ME_URI = '/users/me';
export const USER_LANGUAGE_URI = '/users/me/language';
